/**
 * Return plural noun form
 * @param {number} n
 * @param {string} one
 * @param {string} few
 * @param {string} many
 * @returns string
 * @example
 * ```ts
 * pluralize(6, 'яблоко', 'яблока', 'яблок') -> яблок
 * ```
 */
const pluralize = (n, one, few, many) => {
    const nP100 = n % 100;
    const nP10 = n % 10;
    if (nP10 === 1 && nP100 !== 11) {
        return one;
    }
    if (nP10 >= 2 && nP10 <= 4 && (nP100 < 10 || nP100 >= 20)) {
        return few;
    }
    return many;
};

export { pluralize as p };
//# sourceMappingURL=pluralize-bbc8345a.js.map
